<div class="modal-window-container fx-cover fx-center-all" #container>
    <div class="modal-window-inner" #window>
        <iframe #upgradeDialogFrame [src]="emailVerificationUrl | safe" class="email-verification-window-iframe" allow="clipboard-write"></iframe>
    </div>
</div>